import React from "react";

export const ACCENT = "#D2042D";

export const cx = (...arr) => arr.filter(Boolean).join(" ");

export function Card({ title, subtitle, children, right }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-200 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="text-sm font-black tracking-tight text-slate-900 truncate">{title}</p>
          {subtitle ? <p className="mt-1 text-xs text-slate-500">{subtitle}</p> : null}
        </div>
        {right ? <div className="shrink-0">{right}</div> : null}
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <div>
      <label className="block text-xs font-extrabold tracking-wide text-slate-600">{label}</label>
      <div className="mt-2">{children}</div>
      {hint ? <p className="mt-2 text-xs text-slate-400">{hint}</p> : null}
    </div>
  );
}

export function Input(props) {
  return (
    <input
      {...props}
      className={cx(
        "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-900",
        "outline-none focus:ring-4 focus:ring-[var(--accent)]/10 focus:border-[var(--accent)]",
        props.className
      )}
      style={{ "--accent": ACCENT }}
    />
  );
}

export function TextArea(props) {
  return (
    <textarea
      {...props}
      className={cx(
        "w-full min-h-[120px] rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-900",
        "outline-none focus:ring-4 focus:ring-[var(--accent)]/10 focus:border-[var(--accent)]",
        props.className
      )}
      style={{ "--accent": ACCENT }}
    />
  );
}

export function Button({ variant = "primary", className, ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-3 text-sm font-semibold transition-colors";
  const styles =
    variant === "primary"
      ? "bg-slate-900 text-white hover:bg-[#D2042D]"
      : variant === "danger"
        ? "bg-rose-600 text-white hover:bg-rose-700"
        : "border border-slate-200 bg-white text-slate-900 hover:bg-slate-50";
  return <button {...props} className={cx(base, styles, className)} />;
}

export function Badge({ tone = "neutral", children }) {
  const tones = {
    neutral: "bg-slate-100 text-slate-700",
    info: "bg-blue-50 text-blue-700",
    success: "bg-emerald-50 text-emerald-700",
    warning: "bg-amber-50 text-amber-700",
    danger: "bg-rose-50 text-rose-700",
  };

  return (
    <span className={cx("inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold", tones[tone])}>
      {children}
    </span>
  );
}
